import { datadogRum, type RumActionEventDomainContext } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import { API_ADDRESS, DATADOG_TOKEN, DEPLOYMENT_ENV, VERSION } from '@/constants/env';

export class DatadogManager {
  private static isEnabled() {
    return !!DATADOG_TOKEN;
  }

  public static init() {
    if (!this.isEnabled()) return;

    datadogRum.init({
      applicationId: '35e848fb-0673-40ab-8023-fcade5a46e30',
      clientToken: DATADOG_TOKEN,
      site: 'datadoghq.com',
      service: 'decorator',
      env: DEPLOYMENT_ENV,
      version: VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackResources: true,
      trackUserInteractions: true,
      actionNameAttribute: 'data-testid',
      trackLongTasks: true,
      allowedTracingUrls: [API_ADDRESS.replace(/\/$/, '')],
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin({ router: true })],
      beforeSend: (event, context) => {
        if (event.type === 'action') {
          const { events } = context as RumActionEventDomainContext;
          const target = events?.[0]?.target as Element | undefined;
          const dialog = target?.closest('[data-dialog]')?.getAttribute('data-dialog');
          if (dialog) event.context = { ...event.context, dialog };
        }
        return true;
      },
    });
  }

  public static setUser(user: { id: string; email: string; name?: string }) {
    if (!this.isEnabled()) return;
    datadogRum.setUser(user);
  }

  public static trackDialogShown(dialog: string) {
    if (!this.isEnabled()) return;
    datadogRum.addAction('dialog_shown', { dialog });
  }
}
